/**
 * Validateur dédié aux codes organisation, utilisable avec la lib de validation du Design System
 * @param domNode HTMLElement
 */
export function organizationCodeValidator(domNode) {
    //console.log('organizationCodeValidator called with domNode = ', domNode);
    if (!domNode) {
        return 'error : field missing';
    }
    const value = domNode.value;
    if (!value) {
        return true;
    }
    const type = window.DesignSystem.utils.detectOrganizationCodeType(value);
    //console.log("validation code orga : value= "+value+" // type= "+type);
    if (type === null) {
        return 'invalid'
    }

    return true;
}
